// @flow
import { PropertySelector } from "src/utils/selectorUtils";
import RiskModel from "src/models/propertyModels/RiskModel";
import { RISKS } from "src/reducers/propertyReducers/constants";

class RiskPropertySelectors extends PropertySelector {}

export default new RiskPropertySelectors(RISKS, new RiskModel());
